export default __webpack_public_path__ + "static/media/verified-green-cir.83ef0866.svg";